export enum FILTER_STATES {
  OPEN = 'open',
  COLLAPSED = 'collapsed',
  SELECTING = 'selecting',
}
